module.exports = __webpack_public_path__ + "img/900701076.03db8283.png";